import type { AgentRunsFilters } from './model'

export const AGENT_RUNS_PAGE_SIZE = 50

export const EMPTY_VALUE = '--'

export const AGENT_RUN_PARAM = 'run'

/** Statuses whose final category a reviewer (or an auto-review rule) has settled. */
export const REVIEWED_STATUSES = new Set(['reviewed', 'auto_reviewed'])

export const DOCUMENT_AGENT_QUERY_KEYS = {
  runs: (filters: AgentRunsFilters) => ['document-agent', 'runs', filters] as const,
  documentRuns: (documentKey: string) =>
    ['document-agent', 'documents', documentKey, 'runs'] as const,
  run: (documentKey: string, runId: string) =>
    ['document-agent', 'documents', documentKey, 'runs', runId] as const,
  text: (documentKey: string) => ['document-agent', 'documents', documentKey, 'text'] as const,
}

export const MATCH_SIDE_LABELS = { claim: 'Claim', pa: 'PA' } as const

/** Against the reviewer's final case, on the document's final side. */
export const MATCH_VERDICT_LABELS: Record<string, { label: string; description: string }> = {
  correct: {
    label: 'Agrees with final',
    description: "The agent's decision matches the reviewer's final case",
  },
  wrong: {
    label: 'Differs from final',
    description: "The agent's decision differs from the reviewer's final case",
  },
  in_tie: {
    label: 'Final case in tie',
    description: "The final case is among the agent's tied rows, but is not its candidate",
  },
  no_pick: { label: 'No decision', description: 'The agent submitted no decision on this side' },
  pending: { label: 'Not reviewed yet', description: 'The document has not been reviewed yet' },
  unresolved: {
    label: 'Final case unknown',
    description: "The reviewer's final case could not be resolved from the stored records",
  },
}
